import { useLiveQuery } from 'dexie-react-hooks';

import { useDb } from '../FilesDbProvider';
import { isSyncableFile } from '../isSyncableFile';

export const useSyncableFileCount = (): number => {
  const db = useDb();

  return useLiveQuery(
    () => db.appointmentFiles.filter(isSyncableFile).count(),
    [db],
    0,
  );
};
